import React, { useCallback, useContext } from 'react'
import Group from 'components/utils/Group'
import { pluralizeToString } from 'lib/string/pluralize'
import LineAngleDownIcon from 'LuxKit/Icons/line/LineAngleDownIcon'
import LineUsersAltIcon from 'LuxKit/Icons/line/LineUsersAltIcon'
import AssistChip from 'LuxKit/Chips/AssistChip'
import ModalContext from 'contexts/ModalContext'
import TravellersModal from '../shared/travellers/Modal'
import RoomsModal from '../shared/rooms/Modal'
import { useMultiRoomSelectionOfferPage } from 'businessTraveller/hooks/useMultiRoomSelection'
import LineBedIcon from 'LuxKit/Icons/line/LineBedIcon'

interface Props {
  className?: string
}

function BusinessTravellerSelectHotelsOfferPageMobile({ className }: Props) {
  const {
    totalTravellers,
    roomCount,
  } = useMultiRoomSelectionOfferPage()

  const showModal = useContext(ModalContext)

  const showTravellersModal = useCallback(async() => {
    await showModal(<TravellersModal onApply={() => {}} useSelection={useMultiRoomSelectionOfferPage} />)
  }, [showModal])

  const showRoomsModal = useCallback(async() => {
    await showModal(<RoomsModal onApply={() => {}} useSelection={useMultiRoomSelectionOfferPage} />)
  }, [showModal])

  return (
    <Group className={className} direction="horizontal" gap={8} wrap="wrap">
      <AssistChip
        variant="outline"
        size="medium"
        startIcon={<LineUsersAltIcon />}
        endIcon={<LineAngleDownIcon />}
        onClick={showTravellersModal}
      >
        {totalTravellers > 0 ? pluralizeToString('adult', totalTravellers) : 'Add travellers'}
      </AssistChip>
      <AssistChip
        variant="outline"
        size="medium"
        startIcon={<LineBedIcon />}
        endIcon={<LineAngleDownIcon />}
        onClick={showRoomsModal}
      >
        {pluralizeToString('room', roomCount)}
      </AssistChip>
    </Group>
  )
}

export default BusinessTravellerSelectHotelsOfferPageMobile
